import {inject, Pipe, PipeTransform} from "@angular/core";

import {ValLangueService} from "../../../../../val-definitions-communes-lib/src/public-api";

//Pipe de traduction du libellé d’un dico (menus, traitements, barre de navigation).
//Le libellé vient de la base (habilitations) ; sa traduction est la clé dico.<GUID> du scope
//valcomposantslib, chargé par le bandeau d’application. En langue par défaut, ou sans clé, le libellé
//de la base est affiché tel quel. Impur : il suit le changement de langue et le chargement du scope.
@Pipe (
{
  name: 'val_libelle_dico',
  pure: false
})
export class LibelleDicoPipe implements PipeTransform
{
  private valLangueService = inject (ValLangueService);

  //Transforme le libellé
  //  Paramètres
  //    libelle : Libellé de la base
  //    dico    : Identifiant du dico
  //  Retourne
  //    Libellé dans la langue active
  public transform (libelle: string | null | undefined, dico: string | null | undefined) : string
  {
    if (!libelle)
      return "";

    if (!dico)
      return libelle;

    return this.valLangueService.TraduireLibelleBase ("valcomposantslib.dico." + dico.toLowerCase (), libelle);
  }
}
